// PDF.js for the viewer: loaded on first use (a megabyte no page needs until a
// PDF is shown), in its legacy build — the one with its own polyfills, so an
// older Safari shows the document too. The worker comes as a url vite serves.
let loading = null

/** The PDF.js module, its worker set up. */
export function loadPdfjs() {
  if (loading) return loading
  loading = Promise.all([import("pdfjs-dist/legacy/build/pdf.min.mjs"), import("pdfjs-dist/legacy/build/pdf.worker.min.mjs?url")])
    .then(([pdfjs, worker]) => {
      pdfjs.GlobalWorkerOptions.workerSrc = worker.default
      return pdfjs
    })
    .catch((error) => {
      loading = null
      throw error
    })
  return loading
}

/**
 * Open `src` — a url, or the file's bytes (Uint8Array / ArrayBuffer): a PDF.js
 * loading task (`.promise`, `.destroy()`). The bytes are copied, as PDF.js
 * hands them to its worker and the caller's buffer would be emptied.
 */
export async function openPdf(src, options = {}) {
  const pdfjs = await loadPdfjs()
  if (typeof src === "string") return pdfjs.getDocument({ url: src, ...options })
  const data = src instanceof ArrayBuffer ? new Uint8Array(src.slice(0)) : new Uint8Array(src)
  return pdfjs.getDocument({ data, ...options })
}

/** Is it PDF.js telling that a render was cancelled (a newer one replaced it)? */
export const isCancelled = (error) => error?.name === "RenderingCancelledException"
